import {EmploymentHistoryPositionState, Field } from "../containers"
import {Company} from "../components/employmentHistoryView"

type ServerActionType = 'save' | 'saveAddSuccess' | 'saveUpdateSuccess' | 'saveFailure'
type FieldActionType = 'changeCompanyName' | 'changePositionTitle' 
type DateFieldActionType =  'changeStartDate' | 'changeEndDate'
export type ActionTypes = ServerActionType | FieldActionType | DateFieldActionType | 'changeCompanyId' | 'validateFailure'|'update'

export interface BaseAction {
	type: ActionTypes
}

export interface FieldAction extends BaseAction {
	type: FieldActionType,
	text: string
}

export interface DateFieldAction extends BaseAction {
	type: DateFieldActionType
	text: string
	date: Date
}

export interface ValidateFailure extends BaseAction {
	type: 'validateFailure',
	errorFields:Field[]
}

export interface ServerAction extends BaseAction {
	type: ServerActionType,
}
export interface Save extends ServerAction {
	type: 'save'
}

export interface SaveAddSuccess extends ServerAction {
	type: 'saveAddSuccess'
	id: number
}

export interface SaveUpdateSuccess extends ServerAction {
	type: 'saveUpdateSuccess'
}

export interface SaveFailure extends ServerAction {
	type: 'saveFailure',
	serverErrors:string[]
}
export interface ChangeCompanyName extends FieldAction {
	type: 'changeCompanyName',
	text: string
}

export interface ChangeCompanyId extends BaseAction {
	type: 'changeCompanyId'
	text: string,
	id: number,
}

export interface ChangePositionTitle extends FieldAction {
	type: 'changePositionTitle',
	text: string
}

export type AppAction = FieldAction | ServerAction

export const actionCreator = {
	field: {
		startDateChanged: (text:string, date: Date):DateFieldAction => ({type: 'changeStartDate', text: text, date: date}),
		endDateChanged: (text:string, date: Date):DateFieldAction => ({type: 'changeEndDate', text: text, date: date}),
		changeCompanyName: (newName:string):FieldAction => ({type: 'changeCompanyName', text: newName}),
		changePositionTitle: (newTitle:string):FieldAction => ({type: 'changePositionTitle', text: newTitle}),
		changeCompanyId: (selectorId:string, newCompany:Company|undefined):ChangeCompanyId => {
			let newId = newCompany ? newCompany.companyId : 0
			let newName = newCompany ? newCompany.companyName : ''
			return {type: 'changeCompanyId', id: newId, text: newName}
		},
		validateFailure: (errorFields: Field[]):ValidateFailure => ({type: 'validateFailure', errorFields: errorFields})
	},
	server: {
		save: ():ServerAction => ({type: 'save'}),
		saveAddSuccess: (id: number):ServerAction => ({type: 'saveAddSuccess'}),
		saveUpdateSuccess: ():ServerAction => ({type:'saveUpdateSuccess'}),
		saveFailure: (serverErrors: string[]):SaveFailure => ({type:'saveFailure', serverErrors:serverErrors })
	}
}








// WEBPACK FOOTER //
// ./src/contacts/employmentHistory/actions/index.ts